import { render, staticRenderFns } from "./pages3.vue?vue&type=template&id=4392c2ce&"
import script from "./pages3.vue?vue&type=script&lang=js&"
export * from "./pages3.vue?vue&type=script&lang=js&"
import style0 from "./pages3.vue?vue&type=style&index=0&id=4392c2ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports